import PropTypes from "prop-types"
import { size } from "lodash"
import { ShoppingBasket } from "@mui/icons-material"
import { PERMISSION_LEVEL } from "helpers/shapes"
import { PERMISSION_LEVELS, hasPermission } from "helpers/permissions"
import Resource from "../resource"
import EditSwap from "connected-components/edit-swap"
import { LinkAction, ButtonAction } from "../card-actions"
import { renderAction } from "../../helpers"
import saveRecentResources from "hocs/saveRecentResources"
import { getSwapMenuItems } from "modules/resources/selectors/swaps"
import { Creators as CompositeCreators } from "model/compositeSecurity"

export default function Swap({ handlers, resource, permissionLevel, openDialog, trackResourceEvent, toggleFavorite, account, role, isOpPro, models, dispatch }) {
  const goToSwap = resource => {
    dispatch(CompositeCreators.openCompositeSecurity(account, { ...resource, assetClass: "swap" }))
  }

  const openEditSwap = () => {
    const { editSwap } = handlers
    const EditSwapWithRecentResources = saveRecentResources(EditSwap, "selectedSwap.id")

    openDialog({
      title: "Edit Basket",
      content: <EditSwapWithRecentResources selectedSwap={resource} saveSwap={editSwap} />,
    })
  }

  const trackActionClick = (type, action) => {
    return () => {
      trackResourceEvent({
        trackType: "resources-secondary-link",
        trackPayload: {
          actionType: type,
          resourceType: "basket",
        },
      })
      if (action) action()
    }
  }

  const computeAction = () => {
    const { noData, description, ticker } = resource
    const canEditSwap = role === "admin" || hasPermission(permissionLevel, PERMISSION_LEVELS.WRITE)
    const noModels = !size(models)

    // getCardAction displays only the first valid button
    return renderAction([{
      condition: canEditSwap && noData,
      render: <LinkAction disabled={noModels} onClick={trackActionClick("positions")} to={`/${account}/baskets/${ticker}/upload`}>Upload Positions</LinkAction>,
    }, {
      condition: canEditSwap && !description,
      render: <ButtonAction disabled={noModels} onClick={trackActionClick("description", openEditSwap)}>Add description</ButtonAction>,
    }])
  }

  return <Resource {...{
    account,
    toggleFavorite,
    resource,
    trackResourceEvent,
    onClick: goToSwap,
    resourceType: "basket",
    resourceIcon: <ShoppingBasket />,
    permissionLevel,
    menuItems: getSwapMenuItems(account, resource, isOpPro),
    action: computeAction(),
    models,
    isOpPro,
    dispatch,
  }}
  />
}

Swap.propTypes = {
  handlers: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  permissionLevel: PERMISSION_LEVEL.isRequired,
  openDialog: PropTypes.func.isRequired,
  trackResourceEvent: PropTypes.func.isRequired,
  toggleFavorite: PropTypes.func.isRequired,
  account: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  isOpPro: PropTypes.bool.isRequired,
  models: PropTypes.object,
  dispatch: PropTypes.func,
}
